var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from 'aurelia-templating';
import { autoinject, transient } from 'aurelia-dependency-injection';
import { computedFrom } from 'aurelia-binding';
var Sidebar = /** @class */ (function () {
    function Sidebar() {
        this.isOpen = false;
        this.slideDirection = "right";
        this.tooltipText = "Toggle sidebar";
        this.tooltipColor = "black";
    }
    Object.defineProperty(Sidebar.prototype, "tooltipPosition", {
        get: function () {
            if (this.slideDirection == "left") {
                return "right";
            }
            return "left";
        },
        enumerable: false,
        configurable: true
    });
    Sidebar.prototype.toggle = function ($event) {
        if ($('.button-collapse').hasClass("protip-open")) {
            $('.button-collapse').protipHide();
        }
        this.isOpen = !this.isOpen;
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Sidebar.prototype, "isOpen", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Sidebar.prototype, "slideDirection", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Sidebar.prototype, "tooltipText", void 0);
    __decorate([
        computedFrom('slideDirection'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], Sidebar.prototype, "tooltipPosition", null);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Sidebar.prototype, "tooltipColor", void 0);
    Sidebar = __decorate([
        autoinject,
        transient()
    ], Sidebar);
    return Sidebar;
}());
export { Sidebar };
